import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

// Same /admin/gigs/proposals endpoint as gigProposalPayouts.service.js, but
// this screen deliberately never pins a status filter by default — it's the
// funnel view (every stage), where Payouts is scoped to completed only.
export const gigNegotiationsList = (params = '') => Http.get(`/admin/gigs/proposals${serialize(params)}`)
